import fetch from './fetch';

export const isFormTouched = async (dispatch, entityId, cloned) => {
    
    var response;
    if (cloned) {
        response = await fetch("/funkcionar/api/oznameni/log/opentemplate", dispatch, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
          });
    }
    else if (entityId) {
      response = await fetch(`/funkcionar/api/oznameni/log/open/${entityId}`, dispatch, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' })
      });
    } else {
      response = await fetch("/funkcionar/api/oznameni/log/create", dispatch, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
      });
    }
    if (response.status !== 200) {
        return false;
    }

    return true;
} 